import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getEditorInformationSystemColumns = (
  t: TFunction,
  options: string[]
): ColumnsType<any> =>
  options.map((option) => {
    const baseColumn = {
      title: t(`information_system.${option}`),
      dataIndex: option,
      key: option,
    };

    // Special render for Positions field to display each position on a new line
    if (option === "Positions") {
      return {
        ...baseColumn,
        render: (value: any) => {
          if (Array.isArray(value)) {
            return (
              <>
                {value.map((name, i) => (
                  <p
                    key={i}
                    style={{ fontSize: "12px", color: "#495964", margin: 0 }}
                  >
                    {name}
                  </p>
                ))}
              </>
            );
          }
          return <span>{value}</span>;
        },
      };
    }

    return {
      ...baseColumn,
      render: (value: any) => <span>{value}</span>,
    };
  });
